/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAppointmentStatus.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/general/appointment-status";

export class AutogenModelAppointmentStatus<RowType extends ModelRow> extends Endpoint<RowType, RowAppointmentStatusFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowAppointmentStatus extends ModelRow<RowAppointmentStatusFields> {
    constructor(values?: Partial<RowAppointmentStatusFields>) {
        super(AutogenUserSavedSearchEndpoint, true, values);
    }
}

export interface RowAppointmentStatusFields {
    company_id: string;
    descr: string;
    id: string;
    status_color: number;
}

